/* eslint-disable */
/**
 * Created by MARK 31 s.r.o.
 * User: Pavel Bocek
 * Date: 21.07.21
 */
let markers_list = [];

function initGasStationsMap($) {
  let maps = $('.gas-stations-map');

  if(maps.length > 0) {
    $.each(maps, function(key, element){
      let centerLat = $(this).data('base-lat');
      let centerLng = $(this).data('base-lng');
      let style = $(this).data('map-style');
      let zoom = parseInt($(this).data('zoom'));
      let markers = $(this).data('markers');
      let defaultMarkerIcon = $(this).data('marker-icon');
      let defaultMarkerIconActive = $(this).data('marker-icon-active');
      let markerIcon = defaultMarkerIcon;
      let map_markers = [];

      let options = {
        'zoom': zoom,
        'mapTypeId': google.maps.MapTypeId.ROADMAP,
        'center': new google.maps.LatLng(centerLat, centerLng),
        'scrollwheel': false,
        'draggable': true,
        'streetViewControl': false,
        'mapTypeControl': false,
        'fullscreenControl': false,
        'styles': style
      }

      let gmap = new google.maps.Map($(this).get(0), options);

      if (markers.length > 0) {
        for (let i = 0; i < markers.length; i++) {
          let latLng = new google.maps.LatLng(markers[i][1], markers[i][2]);

          if(markers[i][3]) {
            markerIcon = markers[i][3];
          }else{
            markerIcon = defaultMarkerIcon;
          }

          let marker = new google.maps.Marker({
            'position': latLng,
            'map': gmap,
            'icon': markerIcon,
            'marker_id': markers[i][0],
            'marker_icon': markers[i][3],
            'marker_icon_active': markers[i][4]
          });
          marker.setVisible(true);

          map_markers.push(marker);
          markers_list.push(marker);

          google.maps.event.addListener(marker, 'click', (function(marker) {
            return function() {
              for (let j = 0; j < map_markers.length; j++) {
                if(map_markers[j].marker_icon) {
                  map_markers[j].setIcon(map_markers[j].marker_icon);
                }else{
                  map_markers[j].setIcon(defaultMarkerIcon);
                }
              }

              if(marker.marker_icon_active) {
                this.setIcon(marker.marker_icon_active);
              }else{
                this.setIcon(defaultMarkerIconActive);
              }

              let data = {
                action: 'gas_station_info',
                station_id: marker.marker_id,
                lang: gsm.lang
              };

              $.ajax({
                method: 'POST',
                url: '/wp/wp-admin/admin-ajax.php',
                data: data,
                success: function (res) {
                  $('.gas-station-detail-wrapper').html(res.data.info_html);
                },
                error: function (res) {
                },
              });
            };
          })(marker));
        }
      }
    })
  }
}

(function($) {
  $(window).on('elementor/frontend/init', function () {
    elementorFrontend.hooks.addAction('frontend/element_ready/nl-gas-stations-map.default', initGasStationsMap($));
  });

  $(document).on('click', '.gas-station-info-close', function() {
    for (let j = 0; j < markers_list.length; j++) {
      markers_list[j].setIcon(markers_list[j].marker_icon);
    }
    $('.gas-station-detail-wrapper').html('');
  });

  $(document).on('click', '.gas-stations-list__item .show-on-map', function() {
    $('html,body').animate({
      scrollTop: $('.gas-stations-map').offset().top - 150,
    }, 'slow');

    let gs_id = $(this).data('gs-id');

    for (let j = 0; j < markers_list.length; j++) {
      if(markers_list[j].marker_id === gs_id) {
        markers_list[j].setIcon(markers_list[j].marker_icon_active);
      }else{
        markers_list[j].setIcon(markers_list[j].marker_icon);
      }
    }

    let data = {
      action: 'gas_station_info',
      station_id: gs_id,
      lang: gsm.lang
    };

    $.ajax({
      method: 'POST',
      url: '/wp/wp-admin/admin-ajax.php',
      data: data,
      success: function (res) {
        $('.gas-station-detail-wrapper').html(res.data.info_html);
      },
      error: function (res) {
      },
    });
  });
})(jQuery)





// WEBPACK FOOTER //
// ./scripts/elementor-modules/gas-stations-map.js